import React from 'react';
import { EmbeddedNode } from 'components/shared/RichTextTable/types';
import { Node as ContentfulNode } from '@contentful/rich-text-types';
import { DocumentWithEmbeddedEntries } from 'libs/contentful/props';
import { rewriteEnterpriseSlug } from 'utils/enterprise';

import Link from 'components/shared/Link/Link';

const renderEntryHyperlink = (
  node: ContentfulNode,
  children: React.ReactNode,
  content: DocumentWithEmbeddedEntries,
) => {
  const embeddedNode = node as EmbeddedNode;

  const hyperlinkEntries = content?.links?.entries?.hyperlink || [];
  const entry = hyperlinkEntries.find(i => i.sys.id === embeddedNode.data.target.sys.id);

  if (!entry) return null;

  switch (entry.__typename) {
    case 'Page':
      return buildHyperlink(entry.slug, children);
    default:
      return null;
  }
};

const buildHyperlink = (slug: string | undefined, children: React.ReactNode) => {
  if (!slug) return null;

  const finalSlug = rewriteEnterpriseSlug(slug);
  return (
    <Link href={`/${finalSlug}`} className="inline underline" data-testid="entry-hyperlink">
      {children}
    </Link>
  );
};

export default renderEntryHyperlink;
